import { Platform } from 'react-native';
import { useLayoutContext } from '@/contexts/layout-context';

// Pricing has no native phone layout; web stays reachable at any width.
export const useIsValidPricingLayout = (): boolean => {
  const { isSmallLayout } = useLayoutContext();
  return Platform.OS === 'web' || !isSmallLayout;
};
